import { Box, Button, Modal } from '@mui/material';
import React from 'react';

export default function FirstLoginModal(props: any) {
  const { openLoginModal, handleLoginClose, loginStyle, handleCreateClick, handleOkClick } = props;
  return (
    <Modal
      open={openLoginModal}
      onClose={handleLoginClose} // Handle backdrop clicks
      className="border-0"
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
      disableEscapeKeyDown
    >
      <Box
        sx={{ ...loginStyle, border: 'none', outline: 'none' }}
        className=" px-6 py-2 mx-auto w-full max-w-[310px] sm:max-w-[500px] md:max-w-[500px] lg:max-w-[500px]"
      >
        <div className="w-full flex justify-center">
          <div className="flex items-start w-full flex-col">
            <h1 className="font-semibold text-xl  text-center text-black mt-3">You are not logged in</h1>
            <h2 className="text-sm  text-start text-black mt-1">
              Please create a free account or log in to your account to access this feature.
            </h2>
            <div className="flex w-full justify-end mt-3 mb-2">
              <Button onClick={() => handleCreateClick()} className=" bg-black text-white  px-4">
                <span className="capitalize ">Sign Up</span>
              </Button>
              <Button onClick={() => handleOkClick()} className=" bg-black ms-3 text-white px-6">
                <span className="capitalize">Login</span>
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
